<template>
  <div>
    <h3 style="text-align: center; margin-top: 120px">Halaman belum tersedia</h3>
    <p style="text-align: center">
      Tunggu ya, tim kami masih nyiapin halaman ini
      <br /><br /><br />
      <img src="static/undraw_ideas_re_7twj.svg" width="200" />
    </p>
  </div>
</template>

<script>
export default {
  name: "404",
};
</script>


// WEBPACK FOOTER //
// src/components/404.vue